export default {"src":"/_next/static/media/greenplayer_logo.10d9f97c.svg","height":34,"width":244,"blurWidth":0,"blurHeight":0};